function disable_blogspot_links() {
    $('.module-wysiwyg a').click(function(e) {
        if ($(this).is('[href*="blogspot"]')) {
            e.preventDefault;
            return false;
        }

    });
}

disable_blogspot_links();
